export default function ChallengeStrip({ journey }) {
  return (
    <section className="map-challenge-strip htv-card">
      <div className="map-medal">★</div>
      <div>
        <p className="htv-muted">
          {journey.startLocation} → {journey.endLocation}
        </p>
        <h2>{journey.campaignName}</h2>
      </div>
      <strong>{journey.completedDistance.toFixed(1)} km</strong>
    </section>
  );
}
